
import { mapGetters } from "vuex";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";
import UiZoomImage from "~/components/UI/UiZoomImage.vue";

export default {
  name: "ReviewModalGallery",
  components: {
    UiSwiperCarousel,
    UiZoomImage,
  },
  props: {
    mediaList: {
      type: Array,
      required: true,
    },
    review: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      appBreakpoints: "general/getAppBreakpoints",
    }),
  },
  methods: {
    getMediaUrl(media) {
      return media?.file?.url || media?.url || "";
    },
  },
};
